import React from 'react';
import { Link } from 'react-router-dom';

// Custom hand-drawn SVG wordmark for Plumo
const PlumoLogo = ({ width = 180, className = '' }) => (
  <Link to="/" aria-label="Plumo home" className={className}>
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1000 360" 
      fill="none" 
      stroke="#0D0D0B" 
      strokeWidth="14" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      aria-label="Plumo"
      style={{ width: `${width}px`, height: 'auto' }}
    >
      <path d="M 90 60 Q 88 180 95 320" />
      <path d="M 90 65 Q 175 50 215 105 Q 235 145 200 175 Q 160 195 100 188" />
      <path d="M 95 75 Q 165 62 205 110 Q 222 145 195 170 Q 155 190 105 183" />
      <path d="M 290 75 Q 288 200 295 320" />
      <path d="M 295 78 Q 293 200 300 318" />
      <path d="M 380 175 Q 378 270 410 295 Q 445 305 470 280 Q 475 235 472 180" />
      <path d="M 395 178 Q 393 270 420 293 Q 450 302 468 275 Q 478 230 478 178" />
      <path d="M 472 180 Q 475 230 478 295" />
      <path d="M 555 320 Q 553 240 558 175" />
      <path d="M 558 175 Q 565 145 600 142 Q 635 145 645 178" />
      <path d="M 645 178 Q 648 240 650 320" />
      <path d="M 650 178 Q 658 148 690 145 Q 725 148 735 182" />
      <path d="M 735 182 Q 738 245 742 320" />
      <path d="M 870 200 Q 825 195 815 245 Q 813 295 855 312 Q 900 315 920 280 Q 928 235 895 205 Q 885 200 870 200" />
      <path d="M 875 208 Q 832 205 822 248 Q 822 290 858 305 Q 895 308 915 278 Q 920 240 893 213" />
    </svg>
  </Link>
);

export default PlumoLogo;
